import React,{useState,useEffect,useRef} from "react";
import {Link} from "react-router-dom";
import ImageWithBasePath from "../../../../../core/img";
import FeatherIcon from "feather-icons-react";
import ImageUploading from 'react-images-uploading';
import Select from "react-select";
import {countrys,states} from "../../../../../core/common/selectOption";
import {all_routes} from "../../../../router/all_routes";
/* -- biz9 import start -- */
import {Str} from "biz9-utility";
import {Image_Type,Image_Table} from "biz9-image";
import {Store_Field,Portal_Url} from "biz9-store";
import {Message,Type,Url,Field,Title} from "../../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Dashboard_App_Order_Edit = () => {
    const alert_prop = useRef(null);
    const [user,setUser] = useState(User.get());
    const [photo_primary,setPhotoPrimary] = useState([]);
    const [val_title,setValTitle] = useState(user.title);
    const [val_first_name,setValFirstName] = useState(user.first_name);
    const [val_last_name,setValLastName] = useState(user.last_name);

    const [val_email,setValEmail] = useState(user.email);
    const [val_new_email,setValNewEmail] = useState("");
    const [val_confirm_email,setValConfirmEmail] = useState("");

    const [val_password,setValPassword] = useState(user.password);
    const [val_new_password,setValNewPassword] = useState("");
    const [val_confirm_password,setValConfirmPassword] = useState("");

    const [val_country, setValCountry] = useState(null);
    const [val_state,setValState] = useState(null);
    const [val_city,setValCity] = useState(user.city);
    const [val_gender, setValGender] = useState(user.gender);
    const photo_max_count = 1;
    useEffect(() => {
            get_data();
            },[]);
    async function get_data() {
        setValCountry(countrys.find(option => option.value === user.country));
        setValState(states.find(option => option.value === user.state));
        if(user.image_filename){
            setPhotoPrimary([{image_filename:user.image_filename}]);
        }
    }
    const handle_submit = (event) => {
        event.preventDefault();
    };
    async function btn_post() {
        /*
        let valid_form = false;
        if(Str.check_is_null(val_title)){
            alert_prop.current.showValidation(Message.USERNAME_BAD);
        }
        //email
        if(!Str.check_is_null(val_new_email)){
            if(val_confirm_email != val_new_email){
                alert_prop.current.showValidation(Message.USER_EMAIL_NEW_CONFIRM_BAD);
            }else if(!Str.validate_email(val_new_email)){
                alert_prop.current.showValidation(Message.EMAIL_BAD);
            }else{
                setValEmail(val_new_email);
                valid_form=true;
            }
        }
        //password
        if(!Str.check_is_null(val_new_password)){
            if(val_confirm_password != val_new_password){
                alert_prop.current.showValidation(Message.USER_PASSWORD_NEW_CONFIRM_BAD);
            }else if(!Str.check_is_true(Str.validate_password(val_new_password))){
                alert_prop.current.showValidation(Str.validate_password(val_new_password));
            }else{
                setValPassword(val_new_password);
                valid_form=true;
            }
        }
        else{
            if(!Str.check_is_null(val_new_password)){
                if(val_new_password != val_confirm_password){
                    alert_prop.current.showValidation(Message.PASSWORD_BAD);
                }
            }else{
                valid_form = true;
            }
        }

        if(valid_form){
            user.title = val_title;
            user.title_url = Str.get_title_url(val_title);
            user.first_name = val_first_name;
            user.last_name = val_last_name;
            user.email = val_email;
            user.password = val_password;
            user.city = val_city;
            user.country = !Str.check_is_null(val_country) ? val_country.value : "";
            user.state = !Str.check_is_null(val_state) ? val_state.value : "";
            user.gender = val_gender;
            if(photo_primary.length>0){
                user.image_filename = photo_primary[0].image_filename;
            }else{
                user.image_filename = '';
            }
            let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST)Portal_Url.STORE_ORDER_POST,{parent_table:Portal_Table.PRODUCT,order_number:val_order_number});
            setUser(data.item);
            User.post(data.item);
            alert_prop.current.showValidation(response.message);
        }
        */
    };
    const onPhotoPrimaryChange = (imageList, addUpdateIndex) => {
        setPhotoPrimary(imageList);
    };
    const onPhotoPrimaryDelete = () => {
        if (window.confirm(Message.CONFIRM)) {
            setPhotoPrimary([]);
        }
    }
    const updateValFirstName = (event) => {
        setValFirstName(event.target.value);
    };
    const updateValLastName = (event) => {
        setValLastName(event.target.value);
    };
    const updateValEmail = (event) => {
        setValEmail(event.target.value);
    };
    const updateValNewEmail = (event) => {
        setValNewEmail(event.target.value);
    };
    const updateValConfirmEmail = (event) => {
        setValConfirmEmail(event.target.value);
    };
    const updateValPassword = (event) => {
        setValPassword(event.target.value);
    };
    const updateValNewPassword = (event) => {
        setValNewPassword(event.target.value);
    };
    const updateValConfirmPassword = (event) => {
        setValConfirmPassword(event.target.value);
    };
    const updateValCity = (event) => {
        setValCity(event.target.value);
    };
    const updateValCountry = (selectedOption) => {
        setValCountry(selectedOption);
    };
    const updateValState = (selectedOption) => {
        setValState(selectedOption);
    };
    const updateValGender = (event) => {
        setValGender(event.target.value);
    };
    const updateValTitle = (event) => {
        setValTitle(event.target.value);
    };
    return (
            <>
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content bg-light">
            <div className="row justify-content-center">
            <div className="col-lg-10">
            <div className="main-title mb-4">
            <h4>Settings</h4>
            </div>
            <div className="settings-info bg-white rounded-2">
            <div className="tab-content">
            {/* Profile Settings */}
            <div
            className="tab-pane fade show active"
            id="Personal_Information"
            role="tabpanel"
            >
            <div className="settings-card">
            <div className="settings-card-head bg-light">
            <h4>Personal Information</h4>
            </div>
            <form onSubmit={handle_submit}>

            <div className="settings-card-body">
            <div className="img-upload-head">
            <div className="img-formate">
            <div className="upload-remove-btns">

            <div className="form-wrap">
            <ImageUploading
            value={photo_primary}
    onChange={onPhotoPrimaryChange}
    maxNumber={photo_max_count}
    dataURLKey="image_filename">
    {({
            imageList,
            onImageUpload,
            onImageRemoveAll,
            onImageUpdate,
            isDragging,
            dragProps,
            }) => (
                <div className="upload__image-wrapper">
                <button className="btn btn-secondary mb-2" hidden={photo_primary.length>0}
                style={isDragging ? { color: 'red' } : undefined} onClick={() =>  onImageUpload()}
                {...dragProps} >
                Photo
                </button>
                &nbsp;
                {imageList.map((image, index) => (
                            <div key={index} className="image-item">
                            <img src={image['image_filename']} alt=""  height="200" width="200" />
                            <div className="image-item__btn-wrapper">
                            <Link onClick={() => onPhotoPrimaryDelete() } to="#" className="mb-2" >
                            <FeatherIcon icon="trash-2" />
                            </Link>
                            </div>
                            </div>
                            ))}
                </div>
                )}
    </ImageUploading>
        </div>
        </div>
        </div>
        </div>
        <div className="row">
        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label">
        {" "}
    UserName{" "}
    <span className="text-primary">*</span>
        </label>
        <input  onChange={updateValTitle} value={val_title} type="text" className="form-control" />
        </div>
        </div>

        <div className="col-md-4">
        <div className="form-wrap gig-option">
        <label className="mb-1 fw-medium text-dark d-block mb-2">
        {" "}
    Gender <span className="text-primary">*</span>
        </label>
        <label className="custom_radio">
        <input
        type="radio"
        name="gender"
        value="Male"
        checked={val_gender === 'Male'}
    onChange={updateValGender}
    />

        <span className="checkmark" />
        Male
        </label>
        <label className="custom_radio">

        <input
        type="radio"
        name="gender"
        value="Female"
        checked={val_gender === 'Female'}
    onChange={updateValGender}
    />

        <span className="checkmark" />
        Female
        </label>
        </div>
        </div>

        </div>


        <div className="row">

        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label">
        {" "}
    First Name{" "}
    <span className="text-primary">*</span>
        </label>
        <input value={val_first_name} onChange={updateValFirstName} type="text" className="form-control" />
        </div>
        </div>

        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label">
        {" "}
    Last Name{" "}
    <span className="text-primary">*</span>
        </label>
        <input  value={val_last_name} onChange={updateValLastName} type="text" className="form-control" />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label">
        {" "}
    Email <span className="text-primary">*</span>
        </label>
        <input value={val_email} onChange={updateValEmail} type="email" className="form-control" />
        </div>
        </div>

        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        City<span className="text-primary">*</span>
        </label>
        <input  value={val_city} onChange={updateValCity} type="text" className="form-control" />
        </div>
        </div>

        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        Country<span className="text-primary">*</span>
        </label>
        <Select
        classNamePrefix="react-select"
        className="select"
        styles={Style.customStyles}
    options={countrys}
    value={val_country}
    onChange={updateValCountry}
    />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        State<span className="text-primary">*</span>
        </label>
        <Select
        classNamePrefix="react-select"
        className="select"
        styles={Style.customStyles}
    options={states}
    value={val_state}
    onChange={updateValState}
    />
        </div>
        </div>

        </div>
        </div>
        </form>
        </div>
        <div className="settings-card">
        <div className="settings-card-head bg-light">
        <h4>Change Email</h4>
        </div>

        <form>
        <div className="settings-card-body">
        <div className="row">
        <div className="col-md-4">
        <div className="form-wrap mb-lg-0 mb-md-0">
        <label className="form-label">
        {" "}
    Current Email{" "}
    <span className="text-primary">*</span>
        </label>
        <input disabled={true} value={val_email} type="text" className="form-control" />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap mb-lg-0 mb-md-0">
        <label className="form-label">
        {" "}
    New Email{" "}
    <span className="text-primary">*</span>
        </label>
        <input type="text" onChange={updateValNewEmail} value={val_new_email} className="form-control" />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap mb-0">
        <label className="form-label">
        {" "}
    Confirm Email{" "}
    <span className="text-primary">*</span>
        </label>
        <input type="text" onChange={updateValConfirmEmail} value={val_confirm_email} className="form-control" />
        </div>
        </div>
        </div>
        </div>
        </form>
        </div>


        <div className="settings-card">
        <div className="settings-card-head bg-light">
        <h4>Change Password</h4>
        </div>

        <form>
        <div className="settings-card-body">
        <div className="row">
        <div className="col-md-4">
        <div className="form-wrap mb-lg-0 mb-md-0">
        <label className="form-label">
        {" "}
    Current Password{" "}
    <span className="text-primary">*</span>
        </label>
        <input disabled={true} value={val_password} type="password" className="form-control" />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap mb-lg-0 mb-md-0">
        <label className="form-label">
        {" "}
    New Password{" "}
    <span className="text-primary">*</span>
        </label>
        <input type="text" onChange={updateValNewPassword} value={val_new_password} className="form-control" />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap mb-0">
        <label className="form-label">
        {" "}
    Confirm Password{" "}
    <span className="text-primary">*</span>
        </label>
        <input type="text" onChange={updateValConfirmPassword} value={val_confirm_password} className="form-control" />
        </div>
        </div>
        </div>
        </div>
        </form>
        </div>
        </div>
        {/* /Profile Settings */}
    </div>
    {/* /Page Content */}
    </div>
        <div className="settings-card-footer">
        <div className="btn-item">
        <button onClick={() => btn_post()} className="btn btn-primary" type="submit">
        Save
        </button>
        </div>

        </div>
        </div>
        </div>
        </div>
        {/* /Page Content */}
    {/* Mouse Cursor */}
    <div className="mouse-cursor cursor-outer" />
        <div className="mouse-cursor cursor-inner" />
        {/* /Mouse Cursor */}
    {/* Top Scroll */}
    <div className="back-to-top">
        </div>

        {/* /Top Scroll */}
    </div>
        </>
        );
};

export default Dashboard_App_Order_Edit;
